import * as types from '../actions';

export default function addNewSegmentation(segmentation) {
  return {
    type: types.ADD_NEW_SEGMENTATION,
    segmentation,
  };
}
